module.exports = __webpack_public_path__ + "static/media/AfA-logo-white.597e59f7.svg";